var he = Object.defineProperty, Ve = Object.defineProperties;
var Te = Object.getOwnPropertyDescriptors;
var Y = Object.getOwnPropertySymbols;
var Ae = Object.prototype.hasOwnProperty, ke = Object.prototype.propertyIsEnumerable;
var ee = (m, c, n) => c in m ? he(m, c, { enumerable: !0, configurable: !0, writable: !0, value: n }) : m[c] = n, U = (m, c) => {
  for (var n in c || (c = {}))
    Ae.call(c, n) && ee(m, n, c[n]);
  if (Y)
    for (var n of Y(c))
      ke.call(c, n) && ee(m, n, c[n]);
  return m;
}, te = (m, c) => Ve(m, Te(c));
var C = (m, c, n) => new Promise((E, v) => {
  var O = (f) => {
    try {
      h(n.next(f));
    } catch (i) {
      v(i);
    }
  }, V = (f) => {
    try {
      h(n.throw(f));
    } catch (i) {
      v(i);
    }
  }, h = (f) => f.done ? E(f.value) : Promise.resolve(f.value).then(O, V);
  h((n = n.apply(m, c)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { postTransferQueryParam as Ne } from "../../request/bsplatform/external/commodity/transferQueryParam/post.js";
import { postGetAttributeDataList as Se } from "../../request/bsplatform/attributeDefinition/getAttributeDataList/post.js";
import { getGetMarketLineAttributeColumn as Ie } from "../../request/bsplatform/commodity/getMarketLineAttributeColumn/get.js";
import { getSelectFaucetModel as Me } from "../../request/bsplatform/external/commodity/selectFaucetModel/get.js";
import { postRequestCheckByParams as De } from "../../request/unifiedcheck/universalCheckApi/requestCheckByParams/post.js";
import { postPageCommodityFromOriginalES as xe } from "../../request/commoditycenter/commodity/pageCommodityFromOriginalES/post.js";
import { useLanguage as Ee } from "../../utils/useLanguage.js";
import Oe from "../delivery-method/components/deliveryMethodSelect.ce.vue.js";
import { isCaxaInventory as Le } from "@oppein/op-utils";
import Re from "./components/EditTextAttr.ce.vue.js";
import _e from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import { defineComponent as Ue, useTemplateRef as Fe, onMounted as qe, openBlock as g, createElementBlock as F, createElementVNode as z, createVNode as I, withCtx as A, Fragment as q, renderList as ae, createTextVNode as re, createBlock as S, createCommentVNode as Pe } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as Be } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as d, unref as y } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import Ge from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import je from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import oe from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import { toDisplayString as X } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import ze from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
import le from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import Xe from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import ue from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
const Qe = { class: "tw:!flex tw:!justify-center" }, bt = /* @__PURE__ */ Ue({
  __name: "configurationGoods",
  emits: ["submit", "close", "onChangeDeliveryMethod"],
  setup(m, { expose: c, emit: n }) {
    const { i18n: E } = Ee(), { t: v } = E.global, O = Fe("configurationGoodsContainer"), V = Be(), h = d(!1), f = d([]), i = d({}), k = d([]), N = d([]), Q = d(null), M = d(!1), T = d(), P = d({}), w = d([]), Z = d("LSD"), $ = d([]), H = d(null), D = d(null), L = d([]), J = d({
      readOnlyAttributes: []
    }), ie = d({});
    qe(() => C(this, null, function* () {
    }));
    const K = () => {
      f.value = [], k.value = [], N.value = [], T.value = [], P.value = {}, L.value = [], i.value = {};
    }, se = (e) => C(this, null, function* () {
      var o;
      K(), h.value = !0, w.value = e.tagList, Z.value = (e == null ? void 0 : e.orderType) || "LSD", $.value = (e == null ? void 0 : e.destinationRegion) || "", H.value = (e == null ? void 0 : e.noCheckConfig) || null, E.global.locale.value = (e == null ? void 0 : e.locale) || "zh-CN", yield ne((o = e.inventory) == null ? void 0 : o.commodityId), yield ce(e), yield fe(), yield Promise.all(
        i.value.editableAttributeValue.map((t) => C(this, null, function* () {
          t.attributeValues = Array.isArray(t.attributeValues) ? t.attributeValues : [], t.attributeValues.length === 0 && t.attributeValues.push(""), t.attributeCode !== "fromCaxa" && (f.value[0][t.attributeCode] = [...t.attributeValues]), t.attributeCode === "faucetModel" && (f.value[0].faucetModelDisplayValues = t.attributeValues && t.attributeValues.length > 0 ? t.attributeValues : [""]), yield Promise.all(
            N.value.map((r) => C(this, null, function* () {
              r.attributeCode === t.attributeCode && r.inputType !== "TEXT" && r.options.length < 1 ? r.attributeId !== void 0 && (yield pe(
                r.attributeId,
                i.value.productId || i.value.baseInfo.productId,
                (a) => {
                  r.options = a.dataList.records;
                }
              )) : r.attributeCode === t.attributeCode && r.inputType === "TEXT" && t.attributeCode === "faucetModel" && (r.inputType = "RADIO");
            }))
          );
        }))
      ), T.value = i.value.editableAttributeValue || [], yield de((t) => {
        N.value.forEach((r) => {
          r.attributeCode === "faucetModel" && (r.options = t);
        });
      });
    }), ne = (e) => C(this, null, function* () {
      var o, t, r, a, s;
      try {
        M.value = !0;
        const l = yield xe({
          pageNo: 1,
          pageSize: 10,
          id: e || ""
        });
        l.status && ((t = (o = l.data) == null ? void 0 : o.records) != null && t.length) && (D.value = (r = l.data.records[0].productType) != null ? r : null, Q.value = (s = (a = l.data.records[0]) == null ? void 0 : a.marketClassify) != null ? s : null);
      } catch (l) {
        console.error("Error fetching commodity information:", l);
      } finally {
        M.value = !1;
      }
    }), de = (e) => C(this, null, function* () {
      const o = i.value.attributes.find(
        (r) => r.attributeCode === "classify1"
      ), t = {
        marketClassify: Q.value || null,
        classify1: o.attributeValues.join(",") || null
      };
      yield Me(t).then((r) => {
        if (r) {
          let a = r.map((s) => ({
            displayName: s.model,
            value: s.no
          }));
          L.value = a, e(a);
        }
      });
    }), ce = (e) => C(this, null, function* () {
      const o = ["CUSTOMIZED", "STANDARD", "SAMPLE", "COUPON", "MATERIALS", "QUOTATION"];
      if (D.value && !o.includes(D.value)) {
        console.error(`Invalid productType: ${D.value}`);
        return;
      }
      const t = {
        productType: D.value,
        // 类型断言
        inventory: [e.inventory]
      };
      try {
        const r = yield Ne(t);
        if (!r || !Array.isArray(r.inventory) || r.inventory.length === 0) {
          console.error("Invalid or empty inventory data:", r);
          return;
        }
        const a = r.inventory[0];
        i.value = r.inventory[0], i.value.tagList = w.value, f.value = [
          U({
            commodityName: a.commodityName || "",
            quantity: a.quantity || 1,
            fromCaxa: Le(i.value)
          }, Object.fromEntries(
            (Array.isArray(a.editableAttributeColumn) ? a.editableAttributeColumn : []).map((s) => [s.attributeCode, []])
          ))
        ], k.value = a.editableAttributeColumn;
      } catch (r) {
        console.error("Error fetching transfer query param:", r);
      }
    }), fe = () => C(this, null, function* () {
      var e, o;
      try {
        M.value = !0;
        const t = {
          productType: (e = i.value) == null ? void 0 : e.baseInfo.productType,
          marketClassify: (o = i.value) == null ? void 0 : o.baseInfo.marketClassify
        }, r = yield Ie(t);
        r && r.length > 0 ? N.value = r.map((a) => ({
          attributeId: a.attributeId,
          inputType: a.inputType,
          attributeCode: a.attributeCode,
          options: []
        })) : N.value = [];
      } catch (t) {
        console.error("Failed to fetch market line attribute column:", t), N.value = [], V.error("获取配置属性失败");
      } finally {
        M.value = !1;
      }
    }), pe = (e, o, t) => C(this, null, function* () {
      const r = yield Se({
        attributeId: e,
        productId: o
      });
      r && t(r);
    }), W = () => {
      h.value = !1, K(), j("close");
    }, ye = () => C(this, null, function* () {
      const e = f.value[0];
      e && (T.value = T.value.map(
        (l) => {
          const u = e[l.attributeCode];
          return te(U({}, l), {
            // 保持原有结构（数组形式）
            attributeValues: Array.isArray(u) ? u : [u]
          });
        }
      ));
      const o = new Map(
        T.value.map((l) => {
          var u, p;
          return [
            l.attributeCode,
            (p = (u = l.attributeValues) == null ? void 0 : u[0]) != null ? p : ""
          ];
        })
      ), t = {};
      if (k.value.forEach(({ attributeCode: l }) => {
        t[l] = o.get(l);
      }), i.value.baseInfo.classificationId === "12") {
        const l = yield De({
          checkTypes: "CG_XD",
          checkDatas: {
            commodityList: [
              U({
                commodityId: i.value.baseInfo.commodityId,
                code: i.value.no
              }, t)
            ],
            edit: k.value.map((b) => b.attributeCode)
          }
        }), u = (l == null ? void 0 : l.taskInfoVOList) || [], [p] = u;
        if (p.checkDataResultVO && p.checkDataResultVO.resultLevel) {
          const b = p.checkDataResultVO.resultDesc;
          b && V.error(b);
          return;
        }
      }
      if (f.value.reduce((l, u) => l + u.quantity, 0) != i.value.quantity)
        return V.error(v("商品数量合需要和合计一致")), !1;
      if (f.value.some(
        ({ isNonStand: l = [], faucetModel: u }) => l[0] === "1" && u && !u[0]
      ))
        return V.error(v("请选择水龙头型号！")), !1;
      const a = Object.entries(P.value).find(([, l]) => l);
      if (a) {
        const l = (k.value.find(
          ({ attributeCode: u }) => u === a[0]
        ) || {}).attributeName;
        return V.error(v("请填写完整" + l)), !1;
      }
      let s = me(k.value, T.value);
      if (s.length > 0 && !H.value) {
        const l = s[0].attributeName;
        return V.error(v(l + "必填")), !1;
      }
      T.value.forEach((l) => {
        if (l.attributeCode === "faucetModel")
          if (l.attributeValues && l.attributeValues[0] && Array.isArray(L.value)) {
            const u = L.value.find((p) => {
              var b;
              return p.value === ((b = l.attributeValues) == null ? void 0 : b[0]);
            });
            u ? l.attributeDisplayValues = [u.displayName] : l.attributeDisplayValues = [];
          } else
            l.attributeDisplayValues = [];
      }), h.value = !1, j("submit", T.value);
    }), me = (e, o) => {
      e = e || [], o = o || [];
      let t = [];
      for (let r = 0; r < o.length; r++) {
        let a = o[r];
        if (a.mustEdit && !(a.attributeValues && a.attributeValues.length > 0 && a.attributeValues[0] !== ""))
          return t = e.filter(
            (s) => s.attributeCode === a.attributeCode
          ), t;
      }
      return t;
    }, B = (e, o) => {
      let t = "";
      return Array.isArray(e) && e.forEach((r) => {
        r.attributeCode === o && r.attributeValues && (t = r.attributeValues[0]);
      }), t;
    }, be = (e, o) => e, R = (e, o) => {
      var t, r;
      if (!e || typeof e != "object")
        return "";
      if (o === "isNonStand" && e.isNonStand[0] === "0") {
        const a = i.value.attributes.find(
          (s) => s.attributeCode === "faucetModel"
        );
        e.faucetModel = a.attributeDisplayValues;
      }
      return (!e[o] || !Array.isArray(e[o])) && (e[o] = []), (r = (t = e[o]) == null ? void 0 : t[0]) != null ? r : "";
    }, _ = (e, o, t) => {
      e && (!e[o] || !Array.isArray(e[o]) ? e[o] = [t] : e[o][0] = t, o === "isNonStand" && e.isNonStand[0] === "1" && (e.faucetModel = [""]));
    }, x = (e, o, t) => {
      let r = "", a = [];
      const s = i.value.attributes.find((u) => u.attributeCode === e), l = s == null ? void 0 : s.customOptions;
      if (N.value.forEach((u) => {
        u.attributeCode === e && (r = u.inputType, a = l ? u.options.filter(({ value: p }) => l.includes(p)) : u.options);
      }), Array.isArray(a)) {
        const u = /* @__PURE__ */ new Set();
        a = a.filter((b) => {
          const ge = u.has(b.value);
          return u.add(b.value), !ge;
        });
      }
      if (e === "faucetModel") {
        const u = i.value.attributes.find(
          (p) => p.attributeCode === "faucetModel"
        );
        if (u && u.attributeDisplayValues && u.attributeDisplayValues.length > 0 && t && t.isNonStand == "1") {
          const p = u == null ? void 0 : u.attributeDisplayValues[0];
          a = a.filter((b) => b.value !== p);
        }
      }
      return o === "inputType" ? r || "" : Array.isArray(a) ? a : [];
    }, ve = (e, o) => {
      P.value[e] = o;
    }, G = (e, o) => {
      var t;
      if (e.fromCaxa && ["faucetModel", "isNonStand", "packageType", "installationMode"].includes(o.attributeCode) || o.attributeCode === "faucetModel" && e.packageType && e.packageType[0] === "单盆" || o.attributeCode === "faucetModel" && e.isSelectFaucet && e.isSelectFaucet[0] === "0" || o.attributeCode === "faucetModel" && e.isNonStand && e.isNonStand[0] === "0" || o.attributeCode === "isNonStand" && e.packageType && e.packageType[0] === "单盆" || o.attributeCode === "isNonStand" && e.isSelectFaucet && e.isSelectFaucet[0] === "0")
        return !0;
      if (J.value.readOnlyAttributes)
        return (t = J.value) == null ? void 0 : t.readOnlyAttributes.some((r) => r === o.attributeCode);
    }, Ce = (e, o, t) => {
      j("onChangeDeliveryMethod", e, o, t);
    }, j = n;
    return c({ open: se }), (e, o) => (g(), F(q, null, [
      z("div", {
        ref_key: "configurationGoodsContainer",
        ref: O
      }, null, 512),
      I(y(ze), {
        bordered: "",
        show: h.value,
        "onUpdate:show": o[0] || (o[0] = (t) => h.value = t),
        "mask-closable": !1,
        to: O.value || "body"
      }, {
        default: A(() => [
          I(y(Ge), { show: M.value }, {
            default: A(() => [
              I(y(je), {
                class: "tw:!w-[800px] tw:!box-border tw:!text-left",
                title: y(v)("配置商品参数"),
                "header-class": "tw:!text-center",
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: W
              }, {
                default: A(() => [
                  (g(!0), F(q, null, ae(f.value, (t, r) => (g(), S(y(_e), {
                    ref_for: !0,
                    ref: "formRef" + r,
                    key: "config-form-" + r,
                    inline: "",
                    "label-width": "auto",
                    model: t,
                    "label-placement": "left",
                    rules: ie.value,
                    size: "small",
                    class: "tw:!flex tw:!flex-col tw:!pl-[180px] tw:!box-border tw:!text-left"
                  }, {
                    default: A(() => [
                      I(y(le), {
                        label: y(v)("商品名称"),
                        path: "commodityName"
                      }, {
                        default: A(() => [
                          z("span", null, X(t.commodityName), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]),
                      (g(!0), F(q, null, ae(k.value, (a, s) => (g(), S(y(le), {
                        key: "config-form-" + r + "-col-" + s,
                        label: be(a.attributeName, a.attributeCode)
                      }, {
                        default: A(() => [
                          x(a.attributeCode, "inputType") === "TEXT" ? (g(), S(Re, {
                            key: 0,
                            modelValue: R(t, a.attributeCode),
                            "onUpdate:modelValue": (l) => _(t, a.attributeCode, l),
                            code: a.attributeCode,
                            classify1: B(i.value.attributes, "classify1") || "",
                            classify3: B(i.value.attributes, "classify3") || "",
                            classify4: B(i.value.attributes, "classify4") || "",
                            fromCaxa: t.fromCaxa,
                            isEditRemark: a.attributeCode === "editRemark",
                            inventory: i.value,
                            item: a,
                            onError: ve
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "code", "classify1", "classify3", "classify4", "fromCaxa", "isEditRemark", "inventory", "item"])) : x(a.attributeCode, "inputType") === "NUMBER" ? (g(), S(y(Xe), {
                            key: 1,
                            value: R(t, a.attributeCode),
                            disabled: G(t, a),
                            "onUpdate:value": (l) => _(t, a.attributeCode, l)
                          }, null, 8, ["value", "disabled", "onUpdate:value"])) : x(a.attributeCode, "inputType") === "RADIO" ? (g(), F(q, { key: 2 }, [
                            a.attributeCode === "deliveryMethod" ? (g(), S(Oe, {
                              key: 0,
                              parameter: {
                                deliveryModel: R(t, a.attributeCode),
                                disabled: G(t, a),
                                id: i.value.commodityId,
                                orderType: Z.value,
                                destinationRegion: $.value
                              },
                              "onUpdate:modelValue": (l) => _(t, a.attributeCode, l),
                              onOnChangeDeliveryMethod: Ce
                            }, null, 8, ["parameter", "onUpdate:modelValue"])) : t && t[a.attributeCode] && Array.isArray(t[a.attributeCode]) ? (g(), S(y(ue), {
                              key: 1,
                              value: R(t, a.attributeCode),
                              "onUpdate:value": (l) => _(t, a.attributeCode, l),
                              filterable: a.attributeCode == "faucetModel",
                              disabled: G(t, a),
                              options: x(a.attributeCode, "option", t),
                              "label-field": "displayName",
                              "key-field": "value",
                              class: "tw:!w-[230px]"
                            }, null, 8, ["value", "onUpdate:value", "filterable", "disabled", "options"])) : (g(), S(y(ue), {
                              key: 2,
                              disabled: !0,
                              options: x(a.attributeCode, "option", t),
                              "label-field": "displayName",
                              "key-field": "value",
                              class: "tw:!w-[230px]"
                            }, null, 8, ["options"]))
                          ], 64)) : Pe("", !0)
                        ]),
                        _: 2
                      }, 1032, ["label"]))), 128))
                    ]),
                    _: 2
                  }, 1032, ["model", "rules"]))), 128)),
                  z("div", Qe, [
                    I(y(oe), {
                      type: "primary",
                      size: "small",
                      onClick: ye
                    }, {
                      default: A(() => [
                        re(X(y(v)("确定")), 1)
                      ]),
                      _: 1
                    }),
                    I(y(oe), {
                      size: "small",
                      onClick: W,
                      class: "tw:!ml-5"
                    }, {
                      default: A(() => [
                        re(X(y(v)("取消")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["title"])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  bt as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/configurationGoods.vue.js
// module id = 1223
// module chunks = 41